import React from "react";
import ReactApexChart from "react-apexcharts";
import styles from "../../../assets/css/AdminDashboard/overview.module.css";
import { Card } from "../../../Component/UI/Card";
import { Heading } from "../../../Component/UI/Heading";
import { Payment } from "../../../assets/icons/Payment";
import { Calender } from "../../../Component/UI/Calender";
import { useState } from "react";
import { useEffect } from "react";
import { getDashboardpayment } from "../../../services/admin/dashboard";
import { checkWidth } from "./Overview";

export const OverviewPayments = () => {
  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });

  const [state, setState] = useState();

  useEffect(() => {
    getDashboardpayment(date?.startDate, date?.endDate).then((res) =>
      setState(res?.data?.list)
    );
  }, [date]);

  const series = [
    // {
    //   name: "Billed",
    //   data: state?.graph?.map((item) => item.data?.total),
    // },
    {
      name: "Pending",
      data: state?.graph?.map((item) => item.data?.pending),
    },
    {
      name: "Cancelled",
      data: state?.graph?.map((item) => item.data?.cancelled),
    },
    {
      name: "Received",
      data: state?.graph?.map((item) => item.data?.amount),
    },
  ];

  const options = {
    colors: ["#F19204", "#EB0000", "#18BA4B"],
    chart: {
      height: 300,
      type: "bar",
      stacked: "true",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    animations: {
      enabled: true, //no animations
    },
    dataLabels: {
      enabled: false,
    },

    xaxis: {
      type: "datetime",
      labels: {
        show: true,
        datetimeUTC: false,
      },
      categories: state?.graph?.map((item) => item.date),
    },
    tooltip: {
      enabled: true,
    },
    fill: {
      opacity: 1,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 0,
        columnWidth: checkWidth(state?.graph?.length),
        dataLabels: {
          total: {
            enabled: false,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },

    yaxis: {
      show: true,
      title: {
        text: "Amount (₹/K)",
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
      seriesName: "My Data",
      labels: {
        formatter: function (value) {
          return value;
        },
      },
      axisBorder: {
        show: true,
        color: "#F0F0F0",
        offsetX: 0,
        offsetY: 0,
      },
      // min: 8,
      // max: 40,
      // tickAmount: 4,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      offsetX: 0,
      width: 500,
      markers: {
        radius: 20,
        width: 12,
      },
      itemMargin: {
        horizontal: 20,
        vertical: 0,
      },
    },

    // title: {
    //   text: "XYZ - Stock Analysis (2009 - 2016)",
    //   align: "left",
    //   offsetX: 110,
    // },
    noData: {
      text: "No data is available to plot the graph",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: undefined,
        fontSize: "14px",
        fontFamily: undefined,
      },
    },
  };

  const payment1 = <Payment size="40" outline="#7A51AE" thickness />;
  const payment2 = <Payment size="40" outline="#f7c375" thickness />;
  const payment3 = <Payment size="40" outline="#EB0000" thickness />;
  const payment4 = <Payment size="40" outline="#18BA4B" thickness />;

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "20px 10px",
        }}
      >
        <div className={styles.sub_title}>
          <Heading title="Payments" />
        </div>
        <div>
          <Calender setDateGap={setDate} init />
        </div>
      </div>
      <div className={styles.app_over}>
        <div>
          <Card
            text="Total Billed"
            num={`₹${state?.payments?.total_billed || 0}`}
            icon={payment1}
            color="#f2eef7"
          />
          <Card
            text="Pending"
            num={`₹${state?.payments?.pending || 0}`}
            icon={payment2}
            color="#fef4e6"
          />
          <Card
            text="Cancelled"
            num={`₹${state?.payments?.cancelled || 0}`}
            icon={payment3}
            color="#fde5e5"
          />
          <Card
            text="Received Amounts"
            num={`₹${state?.payments?.received_amount || 0}`}
            icon={payment4}
            color="#e8f8ed"
          />
        </div>
        <div className={styles.mood_div}>
          <ReactApexChart
            className={styles.chart_div}
            options={options}
            type="bar"
            series={series}
            height={400}
            width="100%"
          />
        </div>
      </div>
    </>
  );
};
